var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-viewer"},[_c('div',{staticClass:"menu"},[_c('el-tree',{attrs:{"data":_vm.tree,"default-expand-all":true},on:{"node-click":_vm.scrollToSection}})],1),_c('div',{staticClass:"html-body",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }